module.exports = __webpack_public_path__ + "img/logo_ohhv2.fc968d2d.jpeg";